import { createTheme, lighten, responsiveFontSizes } from '@mui/material/styles';

export const defaultTheme = createTheme();

export const systemPalette = {
  main: "#f5f5f5",
  accent1: "#228CDB",
  accent2: "#9c27b0",
  //highlight colors
  info: "#852197",
  warning: "#F49F0A",
  success: "#40C982",
  error: "#BB2A25",
};

export const createCustomTheme = (palette: {
  main: string;
  accent1: string;
  accent2: string;
  info: string;
  warning: string;
  success: string;
  error: string;
}) => {
  const augmentColor = (hex: string) => defaultTheme.palette.augmentColor({ color: { main: hex } });
  const augmentedBackground = augmentColor(palette.main);

  return responsiveFontSizes(createTheme({
    palette: {
      primary: augmentColor(palette.accent1),
      secondary: augmentColor(palette.accent2),
      error: augmentColor(palette.error),
      warning: augmentColor(palette.warning),
      info: augmentColor(palette.info),
      success: augmentColor(palette.success),
      background: {
        default: augmentedBackground.main,
        paper: augmentedBackground.light,
      },
      text: {
        primary: lighten(augmentedBackground.contrastText, 0.13),
        secondary: lighten(augmentedBackground.contrastText, 0.4),
        disabled: lighten(augmentedBackground.contrastText, 0.62),
      }
    }
  }));
};

export const systemTheme = createCustomTheme(systemPalette);
